module.exports = __webpack_public_path__ + "media/images/weibo-aeb09079389534302f0569c9985c86c1.png";